export default {
  // Settings-related translations
  "settings": "Settings",
  "profile": "Profile",
  "security": "Security",
  "theme": "Theme",
  "feedback": "Feedback",
  "data": "Data",
  "appearance_settings": "Appearance Settings",
  "select_theme": "Select your preferred theme",
  "light": "Light",
  "dark": "Dark",
  "system": "System",
  "language_changed": "Language changed to",
  "failed_update_language": "Failed to update language",
  "profile_settings": "Profile Settings",
  "username_cannot_change": "You cannot change your username for",
  "more_days": "more days",
  "email_cannot_change": "Email cannot be changed",
  "profile_links": "Profile Links",
  "link_one": "Link 1",
  "link_two": "Link 2",
  "password_change": "Change Password",
  "current_password": "Current Password",
  "new_password": "New Password",
  "confirm_password": "Confirm Password",
  "update_password": "Update Password",
  "password_must_be": "Password must be between 8 and 25 characters",
  "security_questions": "Security Questions",
  "security_question": "Security Question",
  "update_security_questions": "Update Security Questions",
  "setup_security_questions": "Set Up Security Questions",
  "select_question": "Select Question",
  "your_answer": "Your Answer",
  "enter_your_answer": "Enter your answer",
  "submit_feedback": "Submit Feedback",
  "feedback_type": "Feedback Type",
  "general_feedback": "General Feedback",
  "bug_report": "Bug Report",
  "feature_request": "Feature Request",
  "airport_request": "Request New Airport",
  "airport_iata": "Airport IATA Code",
  "airport_name": "Airport Name",
  "airport_location": "Airport Location",
  "your_feedback": "Your Feedback",
  "data_management": "Data Management",
  "delete_all_films": "Delete All Films",
  "delete_films_warning": "This will permanently delete all films from your inventory. This action cannot be undone.",
  "delete_all_reviews": "Delete All Reviews",
  "delete_reviews_warning": "This will permanently delete all your reviews. This action cannot be undone.",
  "delete_account": "Delete Account",
  "delete_account_warning": "Warning: This action cannot be undone. This will permanently delete your account and remove all your data from our servers.",
  "language": "Language",
  "language_description": "Change the language used throughout the application",
  "save_language": "Save Language Preference",
  "phone_number": "Phone Number",
  "save_changes": "Save Changes",
  "account_deleted_success": "Your account has been deleted successfully",
  "account_deletion_failed": "Failed to delete account",
  "reviews_deleted_success": "All your reviews have been deleted successfully",
  "reviews_deletion_failed": "Failed to delete reviews",
  "films_deleted_success": "All your films have been deleted successfully",
  "films_deletion_failed": "Failed to delete films",
  "confirm_delete_films": "Are you sure you want to delete all your films? This action cannot be undone.",
  "confirm_delete_reviews": "Are you sure you want to delete all your reviews? This action cannot be undone.",
  "confirm_delete_account": "Are you sure you want to delete your account? This action cannot be undone.",
  "create_username": "Create Username",
  "username_required_description": "Please create a username for your account. Usernames must be unique and can contain letters, numbers, and underscores.",
  "username": "Username",
  "username_placeholder": "Enter a username",
  "username_requirements": "Username must be 4-25 characters and can only contain letters, numbers, and underscores.",
  "save_username": "Save Username",
  "username_taken": "This username is already taken",
  "username_set_success": "Username set successfully",
  "username_set_error": "Failed to set username",
  "display_name": "Display Name",
  "display_name_placeholder": "Enter a display name",
  "no_display_name": "No display name set",
  "create_profile": "Create Your Profile",
  "profile_setup_description": "Please set up your profile to continue. You'll need a unique username and a display name that will be shown to other users.",
  "save_profile": "Save Profile"
};
